var _g, _circle, _path, _path2, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgFoot(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 88,
    height: 94,
    viewBox: "0 0 88 94",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter0_f_54871_1252)"
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 38.1413,
    cy: 38.0867,
    r: 12.5,
    transform: "rotate(15 38.1413 38.0867)",
    fill: "#0071FF"
  }))), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 47.3338,
    cy: 54.0093,
    r: 32.5,
    transform: "rotate(15 47.3338 54.0093)",
    fill: "#0071FF"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M65.6763 56.9614L65.4764 56.5133C64.7099 54.8205 63.9178 53.0664 63.9551 49.234V41.2105C63.9551 40.8073 63.6267 40.4797 63.2243 40.4797C62.8218 40.4797 62.4936 40.8071 62.4936 41.2105V49.227C62.4507 53.3747 63.3499 55.3629 64.1436 57.1157L64.3419 57.5552C65.6479 60.4997 65.8849 62.8474 65.0287 64.3518C64.1407 65.9078 62.3094 66.1518 62.3337 66.1546H32.9331C29.3683 66.0531 28.445 63.978 28.4621 62.7675C28.4708 62.0796 28.7547 61.6414 28.9445 61.6414C30.7421 61.6414 33.8744 61.3004 35.3694 61.0032C39.9617 60.104 48.9315 55.3598 51.445 50.9046C52.2028 49.5657 52.4984 46.4721 52.3497 41.4473L52.3399 41.1154C52.3399 40.7122 52.0129 40.3845 51.6091 40.3845C51.2066 40.3845 50.8784 40.7119 50.8784 41.1154L50.8883 41.4892C51.0683 47.6324 50.5158 49.5727 50.1717 50.1842C47.9239 54.1721 39.4357 58.7138 35.0874 59.5687C33.6567 59.8472 30.6615 60.1767 28.9443 60.1767C27.8396 60.1767 27.0224 61.2545 27.0004 62.7445C26.9683 65.0109 28.7966 67.4972 32.9108 67.6142L62.4135 67.61C62.5192 67.5971 65.0068 67.3074 66.2845 65.0906C67.4106 63.1475 67.2067 60.4128 65.6763 56.9614Z",
    fill: "white"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M53.9755 59.8989C54.675 60.0032 55.3215 60.056 55.9183 60.056C57.8321 60.056 59.2195 59.5138 60.0601 58.4376C61.8401 56.1508 60.3086 52.4293 60.2429 52.2716C60.0887 51.9005 59.6562 51.725 59.288 51.8796C58.9141 52.0346 58.7399 52.4649 58.8954 52.836C59.2521 53.6873 59.9532 56.1937 58.9068 57.5355C58.1532 58.5003 56.5678 58.8113 54.194 58.4518C53.7974 58.3861 53.4233 58.6658 53.3633 59.0623C53.3019 59.465 53.5775 59.8389 53.9755 59.8989Z",
    fill: "white"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "filter0_f_54871_1252",
    x: 0.638184,
    y: 0.583557,
    width: 75.0062,
    height: 75.0062,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "BackgroundImageFix",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 12.5,
    result: "effect1_foregroundBlur_54871_1252"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFoot);
export default __webpack_public_path__ + "static/media/foot.192e503514c2770dddc102251c50831d.svg";
export { ForwardRef as ReactComponent };